import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { FolderKanban, CalendarCheck, HardDriveUpload, BookImage } from 'lucide-react';
import Layout from '../components/Layout';
import ProjectRegister from './ProjectRegister';
import EventWorkflow from './EventWorkflow';
import DataLog from './DataLog';
import AlbumProcessing from './AlbumProcessing';

const TABS = [
  { key: 'projects', label: 'Projects', icon: FolderKanban },
  { key: 'events', label: 'Events', icon: CalendarCheck },
  { key: 'data-log', label: 'Data Log', icon: HardDriveUpload },
  { key: 'albums', label: 'Albums', icon: BookImage },
];

const WorkflowWrapper = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawTab = searchParams.get('tab');
  // Default landing = simplified Events delivery tracker. Legacy 'dashboard' also lands here.
  const activeTab = (!rawTab || rawTab === 'dashboard') ? 'events' : rawTab;

  const handleTabChange = (tab) => {
    // Preserve other params like project, status when switching tabs
    const newParams = new URLSearchParams(searchParams);
    newParams.set('tab', tab);
    setSearchParams(newParams);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'projects': return <ProjectRegister embedded />;
      case 'events': return <EventWorkflow embedded />;
      case 'data-log': return <DataLog embedded />;
      case 'albums': return <AlbumProcessing embedded />;
      default: return <ProjectRegister embedded />;
    }
  };

  return (
    <Layout>
      <div className="border-b border-border bg-card">
        <div className="flex items-center gap-1 px-6 pt-4 overflow-x-auto">
          {TABS.map((tab) => {
            const isActive = activeTab === tab.key;
            return (
              <button
                key={tab.key}
                onClick={() => handleTabChange(tab.key)}
                className={`flex items-center gap-2 px-4 py-3 text-sm font-medium whitespace-nowrap transition-all border-b-2 ${
                  isActive
                    ? 'border-black text-foreground'
                    : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
                }`}
                data-testid={`workflow-tab-${tab.key}`}
              >
                <tab.icon size={16} />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>
      {renderContent()}
    </Layout>
  );
};

export default WorkflowWrapper;
